<template>
  <div id="smenu-edit">
    <Modal v-model="modal.visible" :title="modal.title" footer-hide>
      <IForm :key="modal.visible" :model="edit" :elem="smenuElem" :rules="smenuRule" :loading="loading.form"
             :btn-loading="loading.btn" :width="360" :label-width="100" button button-text="取消" @on-submit="handleSubmit"
             @on-click="modal.visible = false" @on-change="change"/>
      <!-- IForm -->
    </Modal>
  </div>
</template>
<script>
import {_getSmenuUpdate,_getfindParent } from "@/services/manage/smenus"
export default {
  name: "SmenuEdit",
  data() {
    // 自定义验证(年龄)
    return {
      // 模态框属性
      modal: {
        title: "",
        visible: false
      },
      //控制显示
      ishow:false,
      // 表单数据
      edit: {
        name: "",
        alias: "",
        firstMenus: "",
        type: "",
        parendId: "",
        sort: "",
        status: "",
        updateBy: "",
        createdTime: ""
      },
      // 初始表单数据
      init: "",
      // 加载状态
      loading: {
        form: false,
        btn: false
      },
      // 表单元素
      smenuElem: [
        {
          label: "页面名称",
          prop: "name",
          placeholder: "请输入机构名称"
        },
        {
          label: "菜单名称",
          prop: "alias",
          placeholder: "请输入菜单名称"
        },
        {
          label: "菜单URL",
          prop: "url",
          placeholder: "输入菜单URL",
        },
        {
          label: "一级菜单",
          prop: "firstMenu",
          placeholder: "请选择是否一级菜单",
          element: "select",
          events:'change',
          option: [
            {
              label: "是",
              value: 1
            }, {
              label: "否",
              value: 2
            }
          ]
        },
        {
          label: "类型",
          prop: "type",
          placeholder: "请选择类型",
          element: "select",
          option: [
            {
              label: "菜单",
              value: 1
            }, {
              label: "子菜单",
              value: 2
            },{
              label: "导航栏 ",
              value:3
            },{
              label: "按钮",
              value:4
            }
          ]
        },
        {
          label: "上一级菜单",
          prop: "parentId",
          placeholder: "请选择类型",
          element: "select",
          option: [
            {
              label: "菜单",
              value: 1
            }, {
              label: "子菜单",
              value: 2
            },{
              label: "导航栏 ",
              value:3
            },{
              label: "按钮",
              value:4
            }
          ]
        },
        {
          label: "排序",
          prop: "sort",
          placeholder: "输入排序码",
        },
        {
          label: "状态",
          prop: "status",
          placeholder: "选择状态",
          element: "select",
          option: [
            {
              label: "启用",
              value: 1
            }, {
              label: "禁用",
              value: 2
            }
          ]
        }
      ],
      // 表单验证(用户)
      smenuRule: {
        name: [
          {
            required: true,
            message: "页面名称不能为空",
            trigger: "blur"
          }
        ],
        alias: [
          {
            required: true,
            message: "菜单名称不能为空",
            trigger: "blur"
          }
        ],
        url: [
          {
            required: true,
            trigger: "blur",
            message: "菜单URL不能为空"
          }
        ],
        firstMenu: [
          {
            required: true,
            trigger: "blur",
            message: "一级菜单不能为空",
            type:'number'
          }
        ],
        type: [
          {
            required: true,
            trigger: "blur",
            message: "类型不能为空",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit); // 复制初始表单数据
    _getfindParent().then(res=>{
      res.data.forEach(item=>{
        item.value=parseInt(item.id)
        item.label=item.alias
      })
      this.smenuElem[5].option=res.data
    })
  },
  methods: {
    /**
     * 显示模态框
     * @param  {string} title 模态框标题名称
     * @param  {object} row 当前行数据
     */
    handleModal(title, row) {
      this.modal = {
        title: title,
        visible: true
      };
      this.loading.form = true; // 表单加载状态
      if (title =="添加菜单") {
        this.handleCreate(); // 创建
      } else {
        this.handleEdit(row); // 编辑
      }
    },
    // 创建
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.loading.form = false; //
    },
    // 编辑
    handleEdit(row) {
      console.log(row, 'row')
      // 模拟异步请求(获取详情)
      const edit = Object.assign({}, row);
      this.edit = {...edit};
      //console.log(this.edit,'this.edit')
      for (let key in this.edit) {
        if (this.edit.firstMenu==1){
          this.smenuElem[5].disabled=true
        }else{
        this.smenuElem[5].disabled=false
        }
      if (this.edit) {
        this.loading.form = false
      }
    }},
    // 表单提交
    handleSubmit() {
      this.$Loading.start();
      this.loading.btn = true;
      const payload ={
        alias:this.edit.alias,
        firstMenu:this.edit.firstMenu,
        id:+this.edit.id,
        name:this.edit.name,
        parentId:this.edit.firstMenu==1?0:this.edit.parentId,
        sort:this.edit.sort,
        status: this.edit.status,
        type:this.edit.type,
        url:this.edit.url
      }
      // 模拟异步请求(编辑 Or 新增)
      _getSmenuUpdate(payload)
        .then(res => {
          this.$message.success(res.errmsg);
          this.$emit("on-update");
          this.$Loading.finish();
          this.loading.btn = false;
          this.modal.visible = false;
        })
        .catch(() => {
          this.$Loading.error();
          this.loading.btn = false;
          this.modal.visible = false;
        });
    },
    change(e){
      if (e==1){
        return this.smenuElem[5].disabled=true
      }
      this.smenuElem[5].disabled=false
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
